export default __webpack_public_path__ + "static/bookDemoBg-8dd173f917b3c733554ff0d6db288792.png";